<template>
    <div>
        <div v-for="(option, optionIndex) in toggleOptions">
            <toggle
                    @toggle="toggle(optionIndex)"
                    class="pt-3 mr-2"
                    v-model:value="toggleOptions[optionIndex].active">

            </toggle> {{ option.name }}
        </div>
    </div>
</template>

<script>
    import Toggle from "@/components/elements/toggle";

    export default {
        name: "ToggleRadio",
        components: {Toggle},
        model: {
            prop: 'selected',
            event: 'radio-clicked',
        },
        props: {
            options: {
                type: Array,
            },
            selected: {
                Type: String,
                default: null,
            }
        },
        data() {
            let options = []
            let selectedIndex = null

            this.options.forEach((item, index) => {
                let active = false
                if (item === this.selected) {
                    active = item
                    selectedIndex = index
                }
                options.push({
                    name: item,
                    active: active,
                })
            })

            return {
                toggleOptions: options,
                activeOption: selectedIndex,
            }
        },
        methods: {
            toggle(optionIndex) {
                this.toggleOptions.forEach((item, index) => {
                    this.toggleOptions[index].active = index === optionIndex
                })
                this.activeOption = optionIndex
                this.$emit('radio-clicked', this.toggleOptions[optionIndex].name)
            }
        }
    }
</script>

<style scoped>

</style>